/** Swaps two role inputs (e.g. Design surface ↔ As-built survey). */
import { ArrowUpDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export interface SwapButtonProps {
  onSwap: () => void;
  disabled?: boolean;
  testId?: string;
}

export function SwapButton({ onSwap, disabled, testId }: SwapButtonProps) {
  const { t } = useTranslation('project');
  return (
    <div className='flex justify-center'>
      <Button type='button' variant='ghost' size='sm' data-testid={testId} disabled={disabled} onClick={onSwap}>
        <ArrowUpDown className='mr-1 size-4' /> {t('analysisConfig.swap')}
      </Button>
    </div>
  );
}
